module.exports = __webpack_public_path__ + "img/BINDI 5 GREEN.04467ac.svg";